import React from 'react'
import moment from 'moment'
import { Analytics, ResponsiveDialog } from 'common-frontend'
import { OnboardingActions } from 'actions'
import { ChargeUtils } from 'utils'
import { Button } from 'components'

export default class extends React.Component {
  static propTypes = {
    trialAccepted: React.PropTypes.bool
  }

  static contextTypes = {
    currentUser: React.PropTypes.object
  }

  constructor(props) {
    super(props)

    this.state = {
      showDialog: null,
      eligible: null
    }
  }

  componentWillMount() {
    const createdAt = moment(this.context.currentUser.createdAt)
    const showDialog = moment().diff(createdAt, 'hours') < 3
      && this.context.currentUser.activeCharge === false
      && this.props.trialAccepted === null
      && this.context.currentUser.provider === 'shopify'
    if (showDialog === true) {
      Analytics.track('Trial offered')
    }
    this.setState({ showDialog, eligible: showDialog })
  }

  componentWillReceiveProps(nextProps) {
    const showDialog = this.state.eligible === true && nextProps.trialAccepted === null
    this.setState({ showDialog })
  }

  startTrial() {
    OnboardingActions.trialAccepted(true)
    ChargeUtils.upgrade(this.context.currentUser.accessToken)
  }

  render() {
    return (
      <ResponsiveDialog
        title={<h2>Try Plug in SEO Plus?</h2>}
        modal={true}
        open={this.state.showDialog}
      >
        <div>
          <h4 className="medium-spacing2--top">14 Day Free Trial, then $20/month</h4>
          <ul className='icon-font-list large-spacing'>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Improve the SEO of your shop straight away</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Get powerful tools to manage your SEO</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Free installation and premium support</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Video tutorials, detailed help docs</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Downgrade to the free version at any time</li>
          </ul>
          <Button
            label='Yes, start the free trial'
            buttonType="primary"
            onTouchTap={::this.startTrial}
          />
          <Button
            label='No thanks'
            buttonType="secondary"
            onTouchTap={() => OnboardingActions.trialAccepted(false)}
            className="secondary-btn"
          />
        </div>
      </ResponsiveDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/onboarding/Onboarding.js